import { Badge as MuiBadge, type BadgeProps as MuiBadgeProps } from '@mui/material';
import { forwardRef, type ReactNode } from 'react';

export interface CountBadgeProps extends Omit<MuiBadgeProps, 'badgeContent' | 'children'> {
  count: number;
  /** Hide the badge entirely when count is 0. Defaults to true. */
  hideOnZero?: boolean;
  /** Clamp the displayed number. Defaults to 99. */
  max?: number;
  children: ReactNode;
}

/**
 * Count badge — wraps any child with a numeric indicator. Primarily used for
 * tab counts, notification bells, and table filter chips.
 */
export const CountBadge = forwardRef<HTMLSpanElement, CountBadgeProps>(function CountBadge(
  { count, hideOnZero = true, max = 99, color = 'primary', children, ...rest },
  ref,
) {
  return (
    <MuiBadge
      ref={ref}
      color={color}
      badgeContent={count}
      invisible={hideOnZero && count <= 0}
      max={max}
      aria-label={count > 0 ? `${count} items` : undefined}
      {...rest}
    >
      {children}
    </MuiBadge>
  );
});
